export default __webpack_public_path__ + "static/media/Privacy.4b4e83b4.pdf";